import { fetchAuthSession } from "aws-amplify/auth";
import { createContext, type ReactNode, useContext, useMemo } from "react";
import {
  ADMIN_API_URL,
  DEV_ADMIN_EMAIL,
  DEV_ADMIN_SUB,
  DEV_AUTH,
} from "@/lib/auth/cognito-config";
import { type ApiClient, type AuthStrategy, createApiClient } from "./client";

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const client = useMemo(
    () =>
      createApiClient({
        baseUrl: ADMIN_API_URL,
        getAuth: async (): Promise<AuthStrategy> => {
          if (DEV_AUTH) {
            return {
              kind: "dev-headers",
              sub: DEV_ADMIN_SUB,
              email: DEV_ADMIN_EMAIL,
            };
          }
          try {
            const session = await fetchAuthSession();
            const token = session.tokens?.idToken?.toString();
            return token ? { kind: "bearer", token } : null;
          } catch {
            return null;
          }
        },
      }),
    [],
  );
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) throw new Error("useApi() called outside <ApiProvider>");
  return client;
}
